import { Request, BaseApiUrl } from "./api";

// 施工部位
export const getProjectPartListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProjectPart/get`, { params: params });
};
//新增施工部位
export const addProjectPart = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProjectPart/Post`, params);
};
//编辑施工部位信息
export const editProjectPart = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProjectPart/Put`, params);
};
//批量删除
export const batchDeleteProjectPart = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProjectPart/BatchDelete`, params);
};
// export const batchDeleteProjectPart = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ProjectPart/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
